import apiService from '../apiService';

const activityUrl = `${window._env_.ACTIVITY_API_DOMAIN}`;

const patchActionContinueWithOffer = (id) => {
  const url = `${activityUrl}/v1/activity/${id}/action/continue-with-offer`;
  return apiService.patch(url);
};

const patchActionAwaitClientDecision = (id) => {
  const url = `${activityUrl}/v1/activity/${id}/action/awaiting-client-decision`;
  return apiService.patch(url);
};

const patchActionRejectOffer = (id) => {
  const url = `${activityUrl}/v1/activity/${id}/action/reject-offer`;
  return apiService.patch(url);
};

export { patchActionContinueWithOffer, patchActionAwaitClientDecision, patchActionRejectOffer };
